export default __webpack_public_path__ + "static/media/presentationImage.f45caa4c.png";